import baseStyles from '../Base/Base.styles'
import { parseResponsiveProperty } from '@converdy/styles'

export default ({ 
  base,
  width,
  backgroundColor,
  arrowColor,
  discSize,
}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      '& .wrapper': {
        ...parseResponsiveProperty(v => {
          return v && v.value && v.unit ? {
            width: v.value + v.unit,
          } : {} 
        }, width)
      },
      '& .separator': {
        background: backgroundColor,
        color: arrowColor,
        ...parseResponsiveProperty((c) => {
          return c ? {
            '--disc-size': `${c}px`,
          } : {} 
        }, discSize),
      }
    }
  }
  return jss
}